// AccountDeletionPage.jsx
import React, { useState } from 'react';
import axios from 'axios';

const AccountDeletionPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        if (!email || !password) {
            return setMessage('Please provide both email and password.');
        }

        try {
            setLoading(true);
            const response = await axios.delete(
                'https://meriastro-feece6f6a2c0.herokuapp.com/api/users/delete',
                {
                    data: { email, password },
                }
            );
            setMessage(response.data.message || 'Account deleted successfully.');
        } catch (error) {
            const msg =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Something went wrong.';
            setMessage(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto px-6 py-12 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-200">
            <h1 className="text-3xl font-bold mb-4">Delete Your Meriastro Account</h1>
            <p className="mb-6">
                If you would like to request account deletion, please enter your email and
                password below. This will permanently delete your account and any associated
                personal data such as birth date, email, and device ID. We do not store any
                data beyond deletion.
            </p>

            <div className="space-y-4">
                <input
                    type="text"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded"
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded"
                />
                <button
                    onClick={handleDelete}
                    disabled={loading}
                    className="w-full py-2 px-4 bg-red-600 text-white font-bold rounded hover:bg-red-700"
                >
                    {loading ? 'Deleting...' : 'Delete Account'}
                </button>
                {message && <p className="mt-4 text-center text-sm text-red-500">{message}</p>}
            </div>
        </div>
    );
};

export default AccountDeletionPage;